

const EntriesLabel = ({total, rangeStart, rangeEnd}) => {
    if(total>0){
        return (
            <p className="tableMutedText">Showing {rangeStart} to {rangeEnd} of {total} entries</p>
        );
    }
    else{
        return (
            <p className="tableMutedText">Showing 0 to 0 of 0 entries</p>
        );
    }
}

export default EntriesLabel;